import { ConnectionEmployee,ConnectionAffinity,ConnectionRetiree,ConnectionAssociation,Connection, ConnectionGetAffinity } from './../constants/actionType'
const initialState = {
    employee :{
        fNameErr: false,
        lNameErr: false,
        emailErr: false,
        cemailErr: false,
        stateErr: false,
        stateExclusionErr:false,        
        mtnErr:false,
        firstName: "",
        lastName: "",
        eMailID: "",
        ceMailID: "",
        phoneNo: {
            ph1: '',
            ph2: '',
            ph3: ''
        },
        state:"",
        mtn:"",
        enterpriseIDErr:"",
        enterpriseID:"",
        enterpriseIDRespone:null,
        enterpriseIDToken:null,
        validateEmployeeResponse:null,
        validateEmployeeResponseError:false,
        validateEmployeeSystemResponseError:false,
        generateEmployeeTokenError:false,
        eidPageErr:false,
        compPhone: '',
        missingFieldError: false
        // emailValidationResp: '',
        // clickHereFlag: false,
        // emailRegexValid: true,
        // cemailRegexValid: true
    },
    affinity :{
        fNameErr: false,
        lNameErr: false,
        emailErr: false,
        cemailErr: false,
        stateErr: false,
        stateExclusionErr:false,  
        mtnErr:false,
        companyErr:false,
        ssnErr:false,
        firstName: "",
        lastName: "",
        eMailID: "",
        ceMailID: "",
        companyName: "",
        ssn: "",
        phoneNo: {
            ph1: '',
            ph2: '',
            ph3: ''
        },
        state:"",
        mtn:"",
        validateAffinityResponse:null,
        validateAffinityResponseError:false,
        validateAffinitySystemResponseError:false,
        companyList:[],
        showCompanyList:false,
        customerToken:"",
        compPhone: '',
        searchValue: '',
        searchSuggestions: [],
        companyListAffinity: []
        // emailValidationResp: '',
        // clickHereFlag: false,
        // emailRegexValid: true,
        // cemailRegexValid: true

    },
    retiree:{
        lNameErr: false,
        emailErr: false,
        cemailErr: false,
        stateErr: false,
        stateExclusionErr:false,  
        lastName: "",
        eMailID: "",
        ceMailID: "",
        state:"",
        validateRetireeResponse:null,
        validateRetireeResponseError:false,
        validateRetireeSystemResponseError:false,
        retireeToken:null,
        generateRetireeTokenError:false,
        retireeEId:"",
        isDisableLastName:false,
        generateRetireeTokenErrorMsg:"We are unable to process,please try again"
    },
    association:{
        lNameErr: false,
        emailErr: false,
        cemailErr: false,
        stateErr: false,
        stateExclusionErr:false,  
        orgNameErr:false,
        memberIDErr:false,
        cmemberIDErr:false,
        isEligible:false,
        orgName:"",
        memberID:"",
        lastName: "",
        eMailID: "",
        ceMailID: "",
        state:"",
        validateAssociationResponse:null,
        validateAssociationResponseError:false,
        validateAssociationSystemResponseError:false,
        authKeyVal:"",
        companyName:"",
        displayFieldName:"",
        displayFieldValue:"",
        confirmDisplayFieldValue:"",
        associateFieldErr:false,
        confirmassociateFieldErr:false
    },
    getAffinity :{
        lNameErr: false,
        emailErr: false,
        cemailErr: false,
        stateErr: false,
        stateExclusionErr:false,  
        lastName: "",
        eMailID: "",
        ceMailID: "",
        state:"",
        validateGetAffinityResponse:null,
        validateGetAffinityResponseError:false,
        validateGetAffinitySystemResponseError:false,
        urlTagVal:""
    },
    uploadFile:null,
    uploadFileName:"",
    uploadFileNameErr:false,
    uploadFileSizeErr:false,
    proofUpload:"",
}

function connection(state = initialState, action) {
    switch (action.type) {  
        // -- Employee Connection   	
        case ConnectionEmployee.validateInput:
            let employeeInput = Object.assign({}, state.employee, {
                firstName: action.value.firstName !== undefined &&
                    action.value.firstName !== state.employee.firstName ? action.value.firstName : state.employee.firstName,
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.employee.lastName ? action.value.lastName : state.employee.lastName,
                eMailID: action.value.eMailID !== undefined &&
                    action.value.eMailID !== state.employee.eMailID ? action.value.eMailID : state.employee.eMailID,
                ceMailID: action.value.ceMailID !== undefined &&
                    action.value.ceMailID !== state.employee.ceMailID ? action.value.ceMailID : state.employee.ceMailID,
                cemailErr : ((action.value.eMailID !== undefined && action.value.eMailID !== state.employee.ceMailID) 
                    || (action.value.ceMailID !== undefined && action.value.ceMailID !== state.employee.eMailID)) ? true : false,
                // cemailErr : ((action.value.eMailID !== undefined && action.value.eMailID !== state.employee.ceMailID && state.employee.ceMailID != "") 
                //     || (action.value.ceMailID !== undefined && action.value.ceMailID !== state.employee.eMailID)) ? true : !state.employee.cemailRegexValid,
                phoneNo: {
                    ph1: action.value.ph1 !== undefined &&
                        action.value.ph1 !== state.employee.phoneNo.ph1 ? action.value.ph1 : state.employee.phoneNo.ph1,
                    ph2: action.value.ph2 !== undefined &&
                        action.value.ph2 !== state.employee.phoneNo.ph2 ? action.value.ph2 : state.employee.phoneNo.ph2,
                    ph3: action.value.ph3 !== undefined &&
                        action.value.ph3 !== state.employee.phoneNo.ph3 ? action.value.ph3 : state.employee.phoneNo.ph3,
                },
                state: action.value.state !== undefined &&
                    action.value.state !== state.employee.state ? action.value.state : state.employee.state,
                enterpriseID: action.value.enterpriseID !== undefined &&
                    action.value.enterpriseID !== state.employee.enterpriseID ? action.value.enterpriseID : state.employee.enterpriseID,
            })
            return Object.assign({}, state, {
                employee: employeeInput,
            })
        case ConnectionEmployee.fNameErr:
            let fNameError = Object.assign({}, state.employee, {
                fNameErr: action.value
            })
            return Object.assign({}, state, {
                employee: fNameError
            })
        case ConnectionEmployee.lNameErr:
            let lNameError = Object.assign({}, state.employee, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                employee: lNameError
            })
        case ConnectionEmployee.emailErr:
            let emailError = Object.assign({}, state.employee, {
                emailErr: action.value
            })
            return Object.assign({}, state, {
                employee: emailError
            })
        case ConnectionEmployee.cemailErr:
            let cemailError = Object.assign({}, state.employee, {
                cemailErr: action.value
            })
            return Object.assign({}, state, {
                employee: cemailError
            })
        case ConnectionEmployee.stateErr:
            let stateError = Object.assign({}, state.employee, {
                stateErr: action.value
            })
            return Object.assign({}, state, {
                employee: stateError
            })
        case ConnectionEmployee.stateExclusionErr:
            let stateExclusionError = Object.assign({}, state.employee, {
                stateExclusionErr: action.value
            })
            return Object.assign({}, state, {
                employee: stateExclusionError
            })
        case ConnectionEmployee.mtnErr:
            let mtnError= Object.assign({}, state.employee, {
                mtnErr: action.value
            })
            return Object.assign({}, state, {
                employee: mtnError
            })
        case ConnectionEmployee.mtn:
            let mtnValue= Object.assign({}, state.employee, {
                mtn: action.value
            })
            return Object.assign({}, state, {
                employee: mtnValue
            })
        case ConnectionEmployee.enterpriseIDErr:
            let enterpriseIDError = Object.assign({}, state.employee, {
                enterpriseIDErr: action.value
            })
            return Object.assign({}, state, {
                employee: enterpriseIDError
            })
        case ConnectionEmployee.eidPageErr:            
            return Object.assign({}, state, {
                employee: Object.assign({}, state.employee, {
                    eidPageErr: action.value
                })
            })
        case ConnectionEmployee.EnterpriseIDContinue:
            let enterpriseIDRes = Object.assign({}, state.employee, {
                enterpriseIDRespone: action.value
            })
            return Object.assign({}, state, {
                employee: enterpriseIDRes
            })
        case ConnectionEmployee.EnterpriseIDToken:
            let enterpriseIDTokenGen = Object.assign({}, state.employee, {
                enterpriseIDToken: action.value
            })
            return Object.assign({}, state, {
                employee: enterpriseIDTokenGen
            })
        case ConnectionEmployee.validateEmployeeResponse:
            let validateEmployeeRes = Object.assign({}, state.employee, {
                validateEmployeeResponse: action.value
            })
            return Object.assign({}, state, {
                employee: validateEmployeeRes
            })
        case ConnectionEmployee.validateEmployeeResponseError:
            let validateEmployeeResErr = Object.assign({}, state.employee, {
                validateEmployeeResponseError: action.value
            })
            return Object.assign({}, state, {
                employee: validateEmployeeResErr
            })
        case ConnectionEmployee.validateEmployeeSystemResponseError:
            let validateEmployeeSystemResErr = Object.assign({}, state.employee, {
                validateEmployeeSystemResponseError: action.value
            })
            return Object.assign({}, state, {
                employee: validateEmployeeSystemResErr
            })
        case ConnectionEmployee.generateEmployeeTokenError:
            let generateEmployeeTokenErr = Object.assign({}, state.employee, {
                generateEmployeeTokenError: action.value
            })
            return Object.assign({}, state, {
                employee: generateEmployeeTokenErr
            })
        // -- Affinity Connection   	
        case ConnectionAffinity.validateInput:
            let affinityInput = Object.assign({}, state.affinity, {
                firstName: action.value.firstName !== undefined &&
                    action.value.firstName !== state.affinity.firstName ? action.value.firstName : state.affinity.firstName,
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.affinity.lastName ? action.value.lastName : state.affinity.lastName,
                eMailID: action.value.eMailID !== undefined &&
                    action.value.eMailID !== state.affinity.eMailID ? action.value.eMailID : state.affinity.eMailID,
                ceMailID: action.value.ceMailID !== undefined &&
                    action.value.ceMailID !== state.affinity.ceMailID ? action.value.ceMailID : state.affinity.ceMailID,
                cemailErr : ((action.value.eMailID !== undefined && action.value.eMailID !== state.affinity.ceMailID) 
                    || (action.value.ceMailID !== undefined && action.value.ceMailID !== state.affinity.eMailID)) ? true : false,
                // cemailErr : ((action.value.eMailID !== undefined && action.value.eMailID !== state.affinity.ceMailID && state.affinity.ceMailID != "") 
                //     || (action.value.ceMailID !== undefined && action.value.ceMailID !== state.affinity.eMailID)) ? true : !state.employee.cemailRegexValid,
                companyName: action.value.companyName !== undefined &&
                    action.value.companyName !== state.affinity.companyName ? action.value.companyName : state.affinity.companyName,
                ssn: action.value.ssn !== undefined &&
                    action.value.ssn !== state.affinity.ssn ? action.value.ssn : state.affinity.ssn,
                phoneNo: {
                    ph1: action.value.ph1 !== undefined &&
                        action.value.ph1 !== state.affinity.phoneNo.ph1 ? action.value.ph1 : state.affinity.phoneNo.ph1,
                    ph2: action.value.ph2 !== undefined &&
                        action.value.ph2 !== state.affinity.phoneNo.ph2 ? action.value.ph2 : state.affinity.phoneNo.ph2,
                    ph3: action.value.ph3 !== undefined &&
                        action.value.ph3 !== state.affinity.phoneNo.ph3 ? action.value.ph3 : state.affinity.phoneNo.ph3,
                },
                state: action.value.state !== undefined &&
                    action.value.state !== state.affinity.state ? action.value.state : state.affinity.state,
            })
            return Object.assign({}, state, {
                affinity: affinityInput,
            })
        case ConnectionAffinity.fNameErr:
            let afffNameError = Object.assign({}, state.affinity, {
                fNameErr: action.value
            })
            return Object.assign({}, state, {
                affinity: afffNameError
            })
        case ConnectionAffinity.lNameErr:
            let afflNameError = Object.assign({}, state.affinity, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                affinity: afflNameError
            })
        case ConnectionAffinity.emailErr:
            let affemailError = Object.assign({}, state.affinity, {
                emailErr: action.value
            })
            return Object.assign({}, state, {
                affinity: affemailError
            })
        case ConnectionAffinity.cemailErr:
            let affcemailError = Object.assign({}, state.affinity, {
                cemailErr: action.value
            })
            return Object.assign({}, state, {
                affinity: affcemailError
            })
        case ConnectionAffinity.stateErr:
            let affstateError = Object.assign({}, state.affinity, {
                stateErr: action.value
            })
            return Object.assign({}, state, {
                affinity: affstateError
            })
        case ConnectionAffinity.stateExclusionErr:
            let affstateExclusionError = Object.assign({}, state.affinity, {
                stateExclusionErr: action.value
            })
            return Object.assign({}, state, {
                affinity: affstateExclusionError
            })
        case ConnectionAffinity.mtnErr:
            let affmtnError= Object.assign({}, state.affinity, {
                mtnErr: action.value
            })
            return Object.assign({}, state, {
                affinity: affmtnError
            })
        case ConnectionAffinity.mtn:
            let affmtnValue= Object.assign({}, state.affinity, {
                mtn: action.value
            })
            return Object.assign({}, state, {
                affinity: affmtnValue
            })
        case ConnectionAffinity.companyErr:
            let companyError= Object.assign({}, state.affinity, {
                companyErr: action.value
            })
            return Object.assign({}, state, {
                affinity: companyError
            })
        case ConnectionAffinity.ssnErr:
            let ssnError= Object.assign({}, state.affinity, {
                ssnErr: action.value
            })
            return Object.assign({}, state, {
                affinity: ssnError
            })
        case ConnectionAffinity.validateAffinityResponse:
            let validateAffinityRes = Object.assign({}, state.affinity, {
                validateAffinityResponse: action.value
            })
            return Object.assign({}, state, {
                affinity: validateAffinityRes
            })
        case ConnectionAffinity.validateAffinityResponseError:
            let validateAffinityResErr = Object.assign({}, state.affinity, {
                validateAffinityResponseError: action.value
            })
            return Object.assign({}, state, {
                affinity: validateAffinityResErr
            })
        case ConnectionAffinity.validateAffinitySystemResponseError:
            let validateAffinitySystemResErr = Object.assign({}, state.affinity, {
                validateAffinitySystemResponseError: action.value
            })
            return Object.assign({}, state, {
                affinity: validateAffinitySystemResErr
            })
        // -- Retiree Connection
        case ConnectionRetiree.validateInput:
            let retireeInput = Object.assign({}, state.retiree, {
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.retiree.lastName ? action.value.lastName : state.retiree.lastName,
                eMailID: action.value.eMailID !== undefined &&
                    action.value.eMailID !== state.retiree.eMailID ? action.value.eMailID : state.retiree.eMailID,
                ceMailID: action.value.ceMailID !== undefined &&
                    action.value.ceMailID !== state.retiree.ceMailID ? action.value.ceMailID : state.retiree.ceMailID,
                state: action.value.state !== undefined &&
                    action.value.state !== state.retiree.state ? action.value.state : state.retiree.state,
            })
            return Object.assign({}, state, {
                retiree: retireeInput,
            })
        case ConnectionRetiree.lNameErr:
            let retlNameError = Object.assign({}, state.retiree, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                retiree: retlNameError
            })
        case ConnectionRetiree.emailErr:
            let retemailError = Object.assign({}, state.retiree, {
                emailErr: action.value
            })
            return Object.assign({}, state, {
                retiree: retemailError
            })
        case ConnectionRetiree.cemailErr:
            let retcemailError = Object.assign({}, state.retiree, {
                cemailErr: action.value
            })
            return Object.assign({}, state, {
                retiree: retcemailError
            })
        case ConnectionRetiree.stateErr:
            let retstateError = Object.assign({}, state.retiree, {
                stateErr: action.value
            })
            return Object.assign({}, state, {
                retiree: retstateError
            }) 
        case ConnectionRetiree.stateExclusionErr:
            let retstateExclusionError = Object.assign({}, state.retiree, {
                stateExclusionErr: action.value
            })
            return Object.assign({}, state, {
                retiree: retstateExclusionError
            })
        case ConnectionRetiree.validateRetireeResponse:
            let validateRetireeRes = Object.assign({}, state.retiree, {
                validateRetireeResponse: action.value
            })
            return Object.assign({}, state, {
                retiree: validateRetireeRes
            })
        case ConnectionRetiree.validateAssociationResponseError:
            let validateRetireeResponseErr = Object.assign({}, state.retiree, {
                validateRetireeResponseError: action.value
            })
            return Object.assign({}, state, {
                retiree: validateRetireeResponseErr
            })
        case ConnectionRetiree.validateRetireeSystemResponseError:
            let validateRetireeSystemResponseErr = Object.assign({}, state.retiree, {
                validateRetireeSystemResponseError: action.value
            })
            return Object.assign({}, state, {
                retiree: validateRetireeSystemResponseErr
            })
        case ConnectionRetiree.updateLastName:
            return Object.assign({}, state, {
                retiree: Object.assign({}, state.retiree, {
                    lastName: action.value
                })
            })
        case ConnectionRetiree.updateEid:
            return Object.assign({}, state, {
                retiree: Object.assign({}, state.retiree, {
                    retireeEId: action.value
                })
            })
        case ConnectionRetiree.updateLastNameStatus:
            return Object.assign({}, state, {
                retiree: Object.assign({}, state.retiree, {
                    isDisableLastName: action.value
                })
            })
        case ConnectionRetiree.validateRetireeResponseError:
            return Object.assign({}, state, {
                retiree: Object.assign({}, state.retiree, {
                    validateRetireeResponseError: action.value
                })
            })

        case ConnectionRetiree.updateRetireeTokenErrMsg:
            return Object.assign({}, state, {
                retiree: Object.assign({}, state.retiree, {
                    generateRetireeTokenErrorMsg: action.value
                })
            }) 
        case ConnectionRetiree.RetireeToken:
            let retireeTokenGen = Object.assign({}, state.retiree, {
                retireeToken: action.value
            })
            return Object.assign({}, state, {
                retiree: retireeTokenGen
            })
        case ConnectionRetiree.generateRetireeTokenError:
            let generateRetireeTokenErr = Object.assign({}, state.retiree, {
                generateRetireeTokenError: action.value
            })
            return Object.assign({}, state, {
                retiree: generateRetireeTokenErr
            })
        // --Association Connection
        case ConnectionAssociation.validateInput:
            let associationInput = Object.assign({}, state.association, {
                displayFieldValue:action.value.membershipID!==undefined && action.value.membershipID!==state.association.displayFieldValue?action.value.membershipID:state.association.displayFieldValue,
                confirmDisplayFieldValue:action.value.confMembershipID!==undefined && action.value.confMembershipID!==state.association.confirmDisplayFieldValue?action.value.confMembershipID:state.association.confirmDisplayFieldValue,
                 state: action.value.state !== undefined &&
                     action.value.state !== state.association.state ? action.value.state : state.association.state,
                
                // orgName: action.value.orgName !== undefined &&
                //     action.value.orgName !== state.retiree.orgName ? action.value.orgName : state.association.orgName,
                // lastName: action.value.lastName !== undefined &&
                //     action.value.lastName !== state.association.lastName ? action.value.lastName : state.association.lastName,
                // eMailID: action.value.eMailID !== undefined &&
                //     action.value.eMailID !== state.association.eMailID ? action.value.eMailID : state.association.eMailID,
                // ceMailID: action.value.ceMailID !== undefined &&
                //     action.value.ceMailID !== state.association.ceMailID ? action.value.ceMailID : state.association.ceMailID,
                // state: action.value.state !== undefined &&
                //     action.value.state !== state.association.state ? action.value.state : state.association.state,
                // memberID: action.value.memberID !== undefined &&
                //     action.value.memberID !== state.association.memberID ? action.value.memberID : state.association.memberID,
            })
            return Object.assign({}, state, {
                association: associationInput,
            })
        case ConnectionAssociation.orgNameErr:
            let orgNameError = Object.assign({}, state.association, {
                orgNameErr: action.value
            })
            return Object.assign({}, state, {
                association: orgNameError
            })
        case ConnectionAssociation.isEligible:
            let isEligibleValue = Object.assign({}, state.association, {
                isEligible: action.value
            })
            return Object.assign({}, state, {
                association: isEligibleValue
            })
        case ConnectionAssociation.memberIDErr:
            let memberIDError = Object.assign({}, state.association, {
                memberIDErr: action.value
            })
            return Object.assign({}, state, {
                association: memberIDError
            })     
        case ConnectionAssociation.cmemberIDErr:
            let cmemberIDError = Object.assign({}, state.association, {
                cmemberIDErr: action.value
            })
            return Object.assign({}, state, {
                association: cmemberIDError
            }) 

        case ConnectionAssociation.associateFieldErr:             
            return Object.assign({}, state, {
                association: Object.assign({}, state.association, {
                    associateFieldErr: action.value
                })
            }) 

            case ConnectionAssociation.confirmassociateFieldErr:             
            return Object.assign({}, state, {
                association: Object.assign({}, state.association, {
                    confirmassociateFieldErr: action.value
                })
            }) 
            
        case ConnectionAssociation.lNameErr:
            let asslNameError = Object.assign({}, state.association, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                association: asslNameError
            })
        case ConnectionAssociation.emailErr:
            let assemailError = Object.assign({}, state.association, {
                emailErr: action.value
            })
            return Object.assign({}, state, {
                association: assemailError
            })
         case ConnectionAssociation.cemailErr:
            let asscemailError = Object.assign({}, state.association, {
                cemailErr: action.value
            })
            return Object.assign({}, state, {
                association: asscemailError
            })
        case ConnectionAssociation.stateErr:
            let assstateError = Object.assign({}, state.association, {
                stateErr: action.value
            })
            return Object.assign({}, state, {
                association: assstateError
            })
        case ConnectionAssociation.stateExclusionErr:
            let assstateExclusionError = Object.assign({}, state.association, {
                stateExclusionErr: action.value
            })
            return Object.assign({}, state, {
                association: assstateExclusionError
            })
        case ConnectionAssociation.validateAssociationResponse:
            let validateAssociationRes = Object.assign({}, state.association, {
                validateAssociationResponse: action.value
            })
            return Object.assign({}, state, {
                association: validateAssociationRes
            })
        case ConnectionAssociation.validateAssociationResponseError:
            let validateAssociationResponseErr = Object.assign({}, state.association, {
                validateAssociationResponseError: action.value
            })
            return Object.assign({}, state, {
                association: validateAssociationResponseErr
            })
        case ConnectionAssociation.validateAssociationSystemResponseError:
            let validateAssociationSystemResponseErr = Object.assign({}, state.association, {
                validateAssociationSystemResponseError: action.value
            })
            return Object.assign({}, state, {
                association: validateAssociationSystemResponseErr
            })
        //Upload File    
        case Connection.uploadFile:
            return Object.assign({}, state, {
                uploadFile: action.value
            })
        case Connection.fileName:
            return Object.assign({}, state, {
                uploadFileName: action.value
            })
        case Connection.fileNameErr:
            return Object.assign({}, state, {
                uploadFileNameErr: action.value
            })
        case Connection.fileSizeErr:
            return Object.assign({}, state, {
                uploadFileSizeErr: action.value
            })
        case Connection.proofUpload:
            return Object.assign({}, state, {
                proofUpload: action.value
            })
        //Get Affinity
        case ConnectionGetAffinity.validateInput:
            let getAffinityInput = Object.assign({}, state.getAffinity, {
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.getAffinity.lastName ? action.value.lastName : state.getAffinity.lastName,
                eMailID: action.value.eMailID !== undefined &&
                    action.value.eMailID !== state.getAffinity.eMailID ? action.value.eMailID : state.getAffinity.eMailID,
                ceMailID: action.value.ceMailID !== undefined &&
                    action.value.ceMailID !== state.getAffinity.ceMailID ? action.value.ceMailID : state.getAffinity.ceMailID,
                state: action.value.state !== undefined &&
                    action.value.state !== state.getAffinity.state ? action.value.state : state.getAffinity.state,
            })
            return Object.assign({}, state, {
                getAffinity: getAffinityInput,
            })  
        case ConnectionGetAffinity.lNameErr:
            let getAffinitylNameError = Object.assign({}, state.getAffinity, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                getAffinity: getAffinitylNameError
            })
        case ConnectionGetAffinity.emailErr:
            let getAffinityemailError = Object.assign({}, state.getAffinity, {
                emailErr: action.value
            })
            return Object.assign({}, state, {
                getAffinity: getAffinityemailError
            })
        case ConnectionGetAffinity.cemailErr:
            let getAffinitycemailError = Object.assign({}, state.getAffinity, {
                cemailErr: action.value
            })
            return Object.assign({}, state, {
                getAffinity: getAffinitycemailError
            })
        case ConnectionGetAffinity.stateErr:
            let getAffinitystateError = Object.assign({}, state.getAffinity, {
                stateErr: action.value
            })
            return Object.assign({}, state, {
                getAffinity: getAffinitystateError
            }) 
        case ConnectionGetAffinity.stateExclusionErr:
            let getAffinitystateExclusionError = Object.assign({}, state.getAffinity, {
                stateExclusionErr: action.value
            })
            return Object.assign({}, state, {
                getAffinity: getAffinitystateExclusionError
            })
        case ConnectionGetAffinity.updateURLTagValue:            
            return Object.assign({}, state, {
                getAffinity: Object.assign({}, state.getAffinity, {
                    urlTagVal: action.value
                })
            }) 
        case ConnectionAssociation.updateAuthKeyValue:            
            return Object.assign({}, state, {
                association: Object.assign({}, state.association, {
                    authKeyVal: action.value
                })
            })
        case ConnectionAssociation.updateCompanyName:            
            return Object.assign({}, state, {
                association: Object.assign({}, state.association, {
                    companyName: action.value
                })
            })

        case ConnectionAssociation.updateDisplayFieldName:
            return Object.assign({}, state, {
                association: Object.assign({}, state.association, {
                    displayFieldName: action.value
                })
            })
            
        case ConnectionGetAffinity.validateGetAffinityResponse:
            let validateGetAffinityRes = Object.assign({}, state.getAffinity, {
                validateGetAffinityResponse: action.value
            })
            return Object.assign({}, state, {
                getAffinity: validateGetAffinityRes
            })
        case ConnectionGetAffinity.validateGetAffinityResponseError:
            let validateGetAffinityResponseErr = Object.assign({}, state.getAffinity, {
                validateGetAffinityResponseError: action.value
            })
            return Object.assign({}, state, {
                getAffinity: validateGetAffinityResponseErr
            }) 
        case ConnectionGetAffinity.validateGetAffinitySystemResponseError:
            let validateGetAffinitySystemResponseErr = Object.assign({}, state.getAffinity, {
                validateGetAffinitySystemResponseError: action.value
            })
            return Object.assign({}, state, {
                getAffinity: validateGetAffinitySystemResponseErr
            }) 
    case ConnectionAffinity.updateCompanyList : 
        return Object.assign({}, state, {
            affinity: Object.assign({}, state.affinity, {
                companyList: action.value
            })
        }) 

    case ConnectionAffinity.updateCompanyListStatus:        
        return Object.assign({}, state, {
            affinity: Object.assign({}, state.affinity, {
                showCompanyList: action.value
            })
        }) 

    case ConnectionAffinity.updatecustomerTokenDetails:
        return Object.assign({}, state, {
            affinity: Object.assign({}, state.affinity, {
                customerToken: action.value
            })
        })
    
    case Connection.connectionStateReset: 
        return Object.assign ({}, state, initialState);

    case 'UPDATE_COMPLETE_PHONE':
        let compPhoneEmpObj = Object.assign({}, state.employee, {
            compPhone : action.value
        })
        return Object.assign({}, state, {
            employee: compPhoneEmpObj
        })
    case 'UPDATE_EMPLOYEE_FIELD_ERROR':
        let errorEmpObj = Object.assign({}, state.employee, {
            missingFieldError : action.value
        })
        return Object.assign({}, state, {
            employee: errorEmpObj
        })
    // case 'UPDATE_EMPLOYEE_EMAIL_VALIDATION':
    //     let emailValEmpObj = Object.assign({}, state.employee, {
    //         emailValidationResp : action.value
    //     })
    //     return Object.assign({}, state, {
    //         employee: emailValEmpObj
    //     })
    // case 'UPDATE_EMPLOYEE_CLICK_FLAG':
    //     let clickEmpObj = Object.assign({}, state.employee, {
    //         clickHereFlag : action.value
    //     })
    //     return Object.assign({}, state, {
    //         employee: clickEmpObj
    //     })
    // case 'UPDATE_EMPLOYEE_EMAIL_REGEX':
    //     let eRegexEmpObj = Object.assign({}, state.employee, {
    //         emailRegexValid : action.value
    //     })
    //     return Object.assign({}, state, {
    //         employee: eRegexEmpObj
    //     })
    // case 'UPDATE_EMPLOYEE_CONFIRM_EMAIL_REGEX':
    //     let ceRegexEmpObj = Object.assign({}, state.employee, {
    //         cemailRegexValid : action.value
    //     })
    //     return Object.assign({}, state, {
    //         employee: ceRegexEmpObj
    //     })
    // case 'UPDATE_AFFINITY_EMAIL_VALIDATION':
    //     let emailValAffObj = Object.assign({}, state.affinity, {
    //         emailValidationResp : action.value
    //     })
    //     return Object.assign({}, state, {
    //         affinity: emailValAffObj
    //     })
    // case 'UPDATE_AFFINITY_CLICK_FLAG':
    //     let clickAffObj = Object.assign({}, state.affinity, {
    //         clickHereFlag : action.value
    //     })
    //     return Object.assign({}, state, {
    //         affinity: clickAffObj
    //     })
    // case 'UPDATE_AFFINITY_EMAIL_REGEX':
    //     let eRegexAffObj = Object.assign({}, state.affinity, {
    //         emailRegexValid : action.value
    //     })
    //     return Object.assign({}, state, {
    //         affinity: eRegexAffObj
    //     })
    // case 'UPDATE_AFFINITY_CONFIRM_EMAIL_REGEX':
    //     let ceRegexAffObj = Object.assign({}, state.affinity, {
    //         cemailRegexValid : action.value
    //     })
    //     return Object.assign({}, state, {
    //         affinity: ceRegexAffObj
    //     })
    case 'UPDATE_AFFINITY_PHONE':
        let compPhoneAffObj = Object.assign({}, state.affinity, {
            compPhone : action.value
        })
        return Object.assign({}, state, {
            affinity: compPhoneAffObj
        })
    case 'UPDATE_AFFINITY_SEARCH_VALUE':
        let searchValAffObj = Object.assign({}, state.affinity, {
            companyName : action.value
        })
        return Object.assign({}, state, {
            affinity: searchValAffObj
        })
    case 'UPDATE_AFFINITY_SEARCH_SUGGESTION':
        let searchSugAffObj = Object.assign({}, state.affinity, {
            searchSuggestions : action.value
        })
        return Object.assign({}, state, {
            affinity: searchSugAffObj
        })
    case 'UPDATE_AFFINITY_COMPANY_LIST':
        let companyListObj = Object.assign({}, state.affinity, {
            companyListAffinity : action.value
        })
        return Object.assign({}, state, {
            affinity: companyListObj
        })
      default:
              return state
    }
    

}

export default connection